import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[zeroPositiveAndInputLowerThan]',
  providers: [{ provide: NG_VALIDATORS, useExisting: PositiveAndInputLowerThanDirective, multi: true }],
  standalone: true,
})
export class PositiveAndInputLowerThanDirective implements Validator, OnChanges {
  @Input('zeroPositiveAndInputLowerThan') public compareValue: number;
  @Input() public allowZero = false;
  @Input() public minimumValue: number;

  private onValidatorChange: () => void;

  public validate(c: AbstractControl): ValidationErrors | null {
    let validationErrors = null;
    let numValue: number;
    if (typeof c.value === 'string') {
      let valStr = `${c.value}`;
      if (isNaN(c.value as unknown as number)) {
        // Parsen. Annahme: Deutsches Zahlenformat
        valStr = valStr.replace('.', '').replace(',', '.');
      }
      numValue = parseFloat(valStr);
    } else {
      numValue = c.value;
    }

    if (isNaN(numValue)) {
      validationErrors = {
        positiveNonNull: true,
      };
    } else if (this.minimumValue && this.minimumValue > 0 && numValue < this.minimumValue) {
      validationErrors = {
        minimumValue: true,
      };
    } else if (numValue < 0.01 && !this.allowZero) {
      validationErrors = {
        positiveNonNull: true,
      };
    } else if (numValue < 0) {
      validationErrors = {
        positive: true,
      };
    }
    if (!isNaN(numValue) && this.compareValue && numValue > this.compareValue) {
      validationErrors = {
        inputLowerThan: true,
      };
    }

    return validationErrors;
  }

  public registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['minimumValue'] && this.onValidatorChange) {
      // we have to notify the form when validator parameter minimumValue changed,
      // because controls using this validator have to be validated again
      this.onValidatorChange();
    }
  }
}
